import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { Header } from './components/header/header';
import { Toast } from './components/toast/toast';

@Component({
  selector: 'app-root',
  imports: [Header, RouterOutlet, Toast],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly title = signal('kiarafy-frontend');
  protected readonly currentUrl = signal('');
  protected readonly showHeader = computed(() => !this.isPublicRoute(this.currentUrl()));

  private readonly router = inject(Router);

  constructor() {
    this.currentUrl.set(this.router.url);

    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      this.currentUrl.set(event.urlAfterRedirects);
    });
  }

  private isPublicRoute(url: string): boolean {
    const path = url.split('?')[0].split('#')[0];

    return path === '/' || path.startsWith('/login') || path.startsWith('/registrazione') || path.startsWith('/primo-login') || path.startsWith('/forgot-password') || path.startsWith('/reset-password') || path.startsWith('/reset-password-success');
  }
}
